import React from 'react';
import styled from 'styled-components';
import SearchForm from '../../../common/SearchForm/SearchForm';

export default styled(SearchForm)`
  margin: 60px auto;
  max-width: 591px;
`;
